export enum Role {
  ADMIN = 1,
  WHITELABEL_ADMIN = 2,
  CLIENT = 3,
  AGENCY = 4,
  ADVERTISER = 5,
  ORG_ADMIN = 6,
}
